import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  makeStyles,
  Switch,
} from "@material-ui/core";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllResouces,
  getAllRoles,
  getAllSysConfig,
  getApiUserRolesString,
  getSystemProvider,
  getUserRole,
  updatePermissionUser,
} from "../../Utils/actions";
import "../../App.css";
import "./VUser.scss";
import { Card, Modal } from "react-bootstrap";
import { kaReducer, Table } from "ka-table";
import { DataType, SortingMode } from "ka-table/enums";
import { useTranslation } from "react-i18next";
import SaveIcon from "@mui/icons-material/Save";
import { useLocation } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
} from "@mui/icons-material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LastPageIcon from "@mui/icons-material/LastPage";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import { buttonStyle } from "../../Style/ManualStyle";

const VUserRole = ({
  setTabs,
  onPermission,
  rowData,
  setPermission,
  pageIndexAddRole,
  pageSizeAddRole,
}) => {
  const {
    roleList,
    vuserTotalRecord,
    rolesData,
    resourcesData,
    userRolesData,
    allRole,
  } = useSelector((state) => state.data);

  const [form, setForm] = useState({ resource: "", role: "" });
  const [error, setError] = useState({ resource: "", role: "" });
  const { t } = useTranslation();
  const [dataProviderPagination, setDataProviderPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(
    sessionStorage.getItem("rolePerPageSize")
      ? sessionStorage.getItem("rolePerPageSize")
      : 10
  );

  // useEffect(() => {
  //   dispatch(getAllSysConfig({ pageSize: dataProviderPagination.pageSize, pageNumber: dataProviderPagination.pageIndex +1 }))
  //   dispatch(getSystemProvider())
  // }, [])

  useEffect(() => {
    dispatch(getUserRole(form?.role, pageSize, pageIndex));

    // dispatch(getUserRole({roleName: form.role, pagination: {pageSize: dataProviderPagination.pageSize, pageNumber: dataProviderPagination.pageIndex + 1}}))
  }, [pageSize, pageIndex]);

  // const handlePageChange = (newPagination) => {

  //   // setDataProviderPagination((prevState) => ({ ...prevState, pageIndex: newPagination.pageIndex }));
  //   setDataProviderPagination(newPagination);
  // };

  const CheckboxCell = ({ column, dispatch, rowKeyValue, value }) => {
    const handleCheckboxChange = () => {
      dispatch({
        type: "UpdateCellValue",
        columnKey: column.key,
        rowKeyValue,
        value: !value,
      });
    };

    return (
      <input
        type="checkbox"
        checked={value}
        onChange={handleCheckboxChange}
        disabled={column.readonly}
      />
    );
  };

  sessionStorage.setItem("rolePerPageSize", pageSize);

  const roleColumns = useMemo(
    () => [
      // {
      //   accessorKey: "role",
      //   header: "Role Name",
      //   enableEditing: false,
      //   enableResizing: true,
      //   size: 20,
      // },
      {
        accessorKey: "resource",
        header: "Resource Name",
        enableResizing: true,
        size: 20,
      },
      {
        accessorKey: "add",
        header: "Add",
        enableEditing: false,
        enableResizing: true,
        size: 20,
        Cell: ({ cell }) => (
          <Checkbox
            checked={cell.row.original.add}
            readOnly
            style={{ color: "white" }}
          />
        ),
      },
      {
        accessorKey: "read",
        header: "Read",
        enableEditing: false,
        enableResizing: true,
        size: 20,
        Cell: ({ cell }) => (
          <Checkbox
            checked={cell.row.original.read}
            readOnly
            style={{ color: "white" }}
          />
        ),
      },
      {
        accessorKey: "update",
        header: "Update",
        enableEditing: false,
        enableResizing: true,
        size: 20,
        Cell: ({ cell }) => (
          <Checkbox
            checked={cell.row.original.update}
            readOnly
            style={{ color: "white" }}
          />
        ),
      },
      {
        accessorKey: "delete",
        header: "Delete",
        enableEditing: false,
        enableResizing: true,
        size: 20,
        Cell: ({ cell }) => (
          <Checkbox
            checked={cell.row.original.delete}
            readOnly
            style={{ color: "white" }}
          />
        ),
      },
    ],
    [t]
  );

  const roleTablePropsInit = {
    columns: roleColumns,
    data: roleList,
    rowKeyField: "id",
    sortingMode: SortingMode.Single,
  };

  const [roleTableProps, changeRoleTableProps] = useState(roleTablePropsInit);

  const dispatch = useDispatch();
  const [apiString, setApiString] = useState(["N", "N", "N", "N"]);
  const location = useLocation();

  useEffect(() => {
    if (rowData) {
      setForm({ ...form, role: rowData.roleName });
    }
  }, [rowData]);

  useEffect(() => {
    dispatch(getAllRoles(pageSizeAddRole, pageIndexAddRole));
    dispatch(getAllResouces({ pageSize: 10, pageNumber: 1 }));
  }, []);

  useEffect(() => {}, []);

  const handleCheckChange = (e) => {
    setApiString({
      ...apiString,
      [Number(e.target.name)]: e.target.value === "Y" ? "N" : "Y",
    });
  };

  useEffect(() => {
    if (form.role !== "") {
      dispatch(getApiUserRolesString(form.role, pageSize, pageIndex));
      dispatch(getUserRole(form.role, pageSize, pageIndex));
      // dispatch(getUserRole(form.role, { pageNumber: vuserPagination.pageIndex, pageSize: vuserPagination.pageSize }));
    }
  }, [form.role, pageSize, pageIndex]);

  useEffect(() => {
    if (form.resource !== "") {
      setApiString(
        userRolesData[form.resource] !== undefined &&
          userRolesData[form.resource] !== ""
          ? userRolesData[form.resource]?.split("")
          : ["N", "N", "N", "N"]
      );
    }
  }, [form.resource]);

  const handleChange = (e) => {
    setError({ ...error, [e.target.name]: "" });
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.role) {
      setError({ ...error, role: "Role is required" });
      return;
    }
    if (!form.resource) {
      setError({ ...error, resource: "Resources is required" });
      return;
    }
    let permission = Object.values(apiString).join("");

    try {
      form.perm = permission;
      dispatch(updatePermissionUser(form, location, pageSize, pageIndex));
      if (location.pathname === "/validForm") {
        setTabs({ name: "user", val: 1 });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    changeRoleTableProps(roleTablePropsInit);
  }, [roleList]);

  // const dispatchRoleTableAction = (action) => {
  //     changeRoleTableProps((prevState) => kaReducer(prevState, action));
  // };

  const useStyles = makeStyles((theme) => ({
    input: {
      "&::placeholder": {
        color: "#000", // Customize the color here
      },
      color: "#000",
    },
  }));

  const textPlaceHolder = useStyles();
  const modalHideChange = () => {
    setPermission(false);
  };
  const CustomHeader = () => (
    <div
      style={{
        display: "flex",
        // marginTop: "5px",
        // marginBottom: "5px",
        height: "auto",
        wodth: "auto",
        backgroundColor: "#161616",
        // padding:"7px 7px 7px 0px",
      }}
    >
      {rowData?.roleName !== undefined ? (
        <header
          style={{
            color: "#c7c7c7",
            padding: "8px",
            borderRadius: "5px",
            boxShadow: "none",
            margin: "6px 0px",
            backgroundColor: "#161616",
          }}
        >
          {rowData?.roleName}
        </header>
      ) : (
        <header
          style={{
            boxShadow: "none",
            background: "#161616",
            color: "#fff",
            padding: "24.5px",
          }}
        ></header>
      )}
    </div>
  );

  const handlePageChange = (newPageIndex) => {
    setPageIndex(newPageIndex);
  };
  const handleStartChange = () => {
    setPageIndex(0);
  };

  const handleEndChange = () => {
    const totalPages = Math.ceil(vuserTotalRecord / pageSize);
    setPageIndex(totalPages - 1);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageIndex(0);
  };

  return (
    <Fragment>
      {/* <div className="col-md-12"> */}

      {/* <Card.Header
        className="d-flex justify-content-center align-items-center shadow-none"
        style={{ border: "none", backgroundColor: "#286685", color: "#fff" }}
      >
        <strong>User Roles and Permissions Management</strong>
      </Card.Header> */}
      {/* <Card.Header><strong className='headerName'>Add Permission User Role</strong></Card.Header> */}
      <Modal
        show={onPermission}
        onHide={modalHideChange}
        backdrop="static"
        keyboard={false}
        dialogClassName="modal-70w modal-100h"
        centered
      >
        <Modal.Header
          style={{
            backgroundColor: "#161616",
            color: "#c7c7c7",
          }}
        >
          User Role
          <button
            type="button"
            className="close ml-auto"
            style={{
              color: "white",
              height: "12px",
              width: "12px",
              marginRight: "2px",
            }}
            onClick={modalHideChange}
          >
            &times;
          </button>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#333333", color: "#c7c7c7" }}>
          <Box
            component="form"
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
          >
            <div className="col-md-12 d-flex h-100">
              <div className="col-md-12">
                <div className="col-md-12 d-flex">
                  <div className="col-md-6">
                    <FormControl
                      error={!!error.role}
                      style={{ minWidth: "100%" }}
                    >
                      <InputLabel
                        htmlFor="roleName"
                        shrink={true}
                        style={{ color: "#000" }}
                      >
                        User Role
                      </InputLabel>
                      <Select
                        name="role"
                        value={form.role}
                        onChange={handleChange}
                      >
                        {allRole.length > 0 ? (
                          allRole.map((roles, index) => (
                            <MenuItem key={index} value={roles.roleName}>
                              {roles.roleName.toUpperCase()}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value={""} />
                        )}
                      </Select>
                      <FormHelperText>{error.type}</FormHelperText>
                    </FormControl>
                  </div>
                  <div className="col-md-6">
                    <FormControl
                      error={!!error.resource}
                      style={{ minWidth: "100%" }}
                    >
                      <InputLabel
                        htmlFor="type"
                        shrink={true}
                        style={{ color: "#000" }}
                      >
                        Resources
                      </InputLabel>
                      <Select
                        name="resource"
                        value={form.resource}
                        onChange={handleChange}
                      >
                        {resourcesData.length > 0 ? (
                          resourcesData.map((roles, index) => (
                            <MenuItem key={index} value={roles.resourceName}>
                              {roles.resourceName.toUpperCase()}
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem value={""} />
                        )}
                      </Select>
                      <FormHelperText>{error.type}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <FormGroup>
                  <div
                    className="col-md-12 d-flex userole_model"
                    style={{ top: "10px", right: "15px", color: "#c7c7c7" }}
                  >
                    <div className="col-md-6">
                      <div className="col-md-6 my-2">
                        <FormControlLabel
                          control={
                            <Switch
                              defaultChecked={false}
                              checked={apiString[0] === "Y"}
                              value={apiString[0]}
                              name="0"
                              className="switchCase"
                              onChange={handleCheckChange}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label="ADD"
                        />
                      </div>
                      <div className="col-md-6 my-2">
                        <FormControlLabel
                          control={
                            <Switch
                              defaultChecked={false}
                              checked={apiString[1] === "Y"}
                              value={apiString[1]}
                              name="1"
                              className="switchCase"
                              onChange={handleCheckChange}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label="READ"
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="col-md-6 my-2">
                        <FormControlLabel
                          control={
                            <Switch
                              defaultChecked={false}
                              checked={apiString[2] === "Y"}
                              value={apiString[2]}
                              name="2"
                              className="switchCase"
                              onChange={handleCheckChange}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label="UPDATE"
                        />
                      </div>
                      <div className="col-md-6">
                        <FormControlLabel
                          control={
                            <Switch
                              defaultChecked={false}
                              checked={apiString[3] === "Y"}
                              value={apiString[3]}
                              name="3"
                              className="switchCase"
                              onChange={handleCheckChange}
                              inputProps={{ "aria-label": "controlled" }}
                            />
                          }
                          label="DELETE"
                        />
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </Box>
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#161616" }}>
          {/* <div className="col-md-6" style={{ top: "3px", left: "15px" }}> */}
          <Button type="submit" startIcon={<SaveIcon />} style={buttonStyle}>
            Save
          </Button>
          {/* </div> */}
        </Modal.Footer>
      </Modal>
      <div className="" style={{ height: "100%", overflow: "auto" }}>
        <div
          style={{
            display: "block",
            position: "relative",
          }}
        >
          <div className="m-0  overflow-auto border-0">
            <MaterialReactTable
              muiTabEditIconleHeadCellProps={{
                sx: {
                  backgroundColor: "#2e2e2e",
                  color: "#ccc",
                },
              }}
              muiTableProps={{
                sx: {
                  overflow: "scroll",
                  border: "none",
                },
                // sx: {
                //     height: '70vh', // Set height to 100% of the container
                //     width: '100%', // Set width to 100% of the container
                // }
              }}
              muiTablePaperProps={{
                sx: {
                  boxShadow: "none",
                  // height: "75%",
                  height: "auto",
                  // height: '100vh',
                  // height: '100vh', // Set height to 100% of the container
                  width: "100%", // Set width to 100% of the container
                  position: "relative",
                  display: "block",
                  // overflow: "scroll",
                  // overflow: 'scroll',
                  backgroundColor: "#23272f", // dark table background
                  scrollbarWidth: "thin",
                  "&::-webkit-scrollbar": {
                    width: "12px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#444",
                    borderRadius: "6px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#23272f",
                  },
                },
              }}
              muiTableContainerProps={{
                sx: {
                  maxHeight: "60vh",
                  overflowY: "auto",
                  overflowX: "auto",
                  backgroundColor: "#181818", // dark container
                },
              }}
              muiTableHeadCellProps={{
                sx: {
                  backgroundColor: "#2e2e2e",
                  color: "#ccc",
                },
              }}
              muiTableBodyRowProps={({ row, index }) => ({
                sx: {
                  backgroundColor: row.getIsSelected()
                    ? "1c1c1c"
                    : // : index % 2 === 0
                      // ? "#cfd5e959"
                      "121212",
                },
              })}
              muiTableBodyProps={{
                sx: {
                  overflow: "auto",
                  scrollbarWidth: "thin",
                  backgroundColor: "#181818", // dark body
                  "&::-webkit-scrollbar": {
                    width: "10px",
                    backgroundColor: "#181818",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#444",
                    borderRadius: "6px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: "#555",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#23272f",
                  },
                  // "& tr:nth-of-type(odd)": {
                  //   backgroundColor: "#23272f",
                  // },
                  // "& tr:nth-of-type(even)": {
                  //   backgroundColor: "#181818",
                  // },
                  "& td": {
                    padding: "0.5rem",
                    borderBottom: "1px solid #333",
                    color: "#c7c7c7",
                  },
                },
              }}
              // muiTablePaperProps={{ sx: { boxShadow: 'none', height: '60vh', position: 'flex', overflow: 'scroll' } }}
              renderTopToolbar={() => <CustomHeader />}
              columns={roleColumns}
              data={roleList}
              enableRowActions={false}
              enableEditing={false}
              enableStickyHeader={true}
              enableStickyFooter={true}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              positionActionsColumn="last"
              editDisplayMode="row"
              enableFilters={false}
              enableHiding={false}
              muiPaginationProps={({ table }) => ({
                showRowsPerPage: true,
              })}
              enablePagination={false}
              renderBottomToolbarCustomActions={({ table }) => (
                <>
                  <div style={{ marginLeft: "auto", color: "#c7c7c7" }}>
                    <span>Rows per Page </span>&nbsp;
                    <FormControl variant="standard" size="small">
                      <Select
                        value={pageSize}
                        onChange={(e) =>
                          handlePageSizeChange(Number(e.target.value))
                        }
                        sx={{
                          color: "#c7c7c7",
                          ".MuiSelect-icon": { color: "#c7c7c7" },
                          ".MuiOutlinedInput-notchedOutline": {
                            borderColor: "#444",
                          },
                        }}
                      >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={50}>50</MenuItem>
                        <MenuItem value={100}>100</MenuItem>
                      </Select>
                    </FormControl>
                    &nbsp;
                    <span>
                      {pageIndex * pageSize + 1}-
                      {Math.min(
                        pageIndex * pageSize + pageSize,
                        vuserTotalRecord
                      )}{" "}
                      of &nbsp;
                      {vuserTotalRecord}&nbsp;
                    </span>
                    <FirstPageIcon
                      onClick={() => {
                        if (pageIndex !== 0) {
                          handleStartChange();
                        }
                      }}
                      style={{
                        cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                        color:
                          pageIndex === 0
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                    <NavigateBeforeIcon
                      onClick={() => {
                        if (pageIndex !== 0) {
                          handlePageChange(pageIndex - 1);
                        }
                      }}
                      style={{
                        cursor: pageIndex === 0 ? "not-allowed" : "pointer",
                        color:
                          pageIndex === 0
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                    <NavigateNextIcon
                      onClick={() => {
                        if ((pageIndex + 1) * pageSize < vuserTotalRecord) {
                          handlePageChange(pageIndex + 1);
                        }
                      }}
                      style={{
                        cursor:
                          (pageIndex + 1) * pageSize >= vuserTotalRecord
                            ? "not-allowed"
                            : "pointer",
                        color:
                          (pageIndex + 1) * pageSize >= vuserTotalRecord
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                    <LastPageIcon
                      onClick={() => {
                        if ((pageIndex + 1) * pageSize < vuserTotalRecord) {
                          handleEndChange();
                        }
                      }}
                      style={{
                        cursor:
                          (pageIndex + 1) * pageSize >= vuserTotalRecord
                            ? "not-allowed"
                            : "pointer",
                        color:
                          (pageIndex + 1) * pageSize >= vuserTotalRecord
                            ? "rgba(255,255,255,0.26)"
                            : "#c7c7c7",
                      }}
                    />
                  </div>
                </>
              )}
              // paginationDisplayMode="pages"
              // manualPagination={true}
              rowCount={vuserTotalRecord}
              // onPaginationChange={(newPagination) => {
              //   setDataProviderPagination(newPagination);
              // }}
              state={dataProviderPagination}
              renderRowActions={({ row, table }) => (
                <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                  <IconButton
                    // sx={{ color: "#000" }}
                    onClick={() => {
                      table.setEditingRow(row);
                    }}
                  >
                    <EditIcon sx={{ color: "#c7c7c7" }} />
                  </IconButton>
                </Box>
              )}
            />
          </div>
        </div>
      </div>
      {/* </div> */}
    </Fragment>
  );
};

export default VUserRole;
